import axios from 'axios'

const standardURL = 'api/'

class ServiceHandler {
  //    Get elements
  static getElements (coleccion) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await axios.get(`${standardURL}${coleccion}`, {
          headers: {
            'Access-Control-Allow-Origin': '*'
          }})
        const data = res.data
        resolve(
          data.map(post => ({
            ...post
          }))
        )
      } catch (err) {
        reject(err)
      }
    })
  }
  static getYear (coleccion) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await axios.get(`${standardURL}${coleccion}`, {
          headers: {
            'Access-Control-Allow-Origin': '*'
          }})
        const data = res.data
        resolve(
          data
        )
      } catch (err) {
        reject(err)
      }
    })
  }
  static getInfoSesion (datos) {
    const params = {
      headers: {
        'UserName': datos.usuario,
        'Pass': datos.password,
        'token': datos.token,
      }
    };
    
    return new Promise(async (resolve, reject) => {
      try {
        const res = await axios.get(`https://webapiservice.bamx.org.mx/api/Login/validaAcceso`, params)
        resolve(res.data)
      } catch (err) {
        reject("Se encontró un error: " + err)
      }
    })
  }
  static getLoginLocal (datos) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await axios.post(`${standardURL}usuarios/login`, datos, {
          headers: {
            'Access-Control-Allow-Origin': '*'
          }})
        const data = res.data
        resolve(
          data.map(post => ({
            ...post
          }))
        )
      } catch (err) {
        reject(err)
      }
    })
  }
  static getElement (coleccion, id) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await axios.get(`${standardURL}${coleccion}/${id}`, {
          headers: {
            'Access-Control-Allow-Origin': '*'
          }})
        const data = res.data
        resolve(
          data.map(post => ({
            ...post
          }))
        )
      } catch (err) {
        reject(err)
      }
    })
  }
  static subirImagen (tipo, imagen) {
    var direccion = `${standardURL}subir_imagenes/${tipo}`
    axios.post(direccion, imagen, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then((response) => {
      return 'OK'
    }).catch((error) => {
      alert(`Se originó un fallo al subir ${tipo}: ${error}`)
    })
  }
  static getID (code) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log(`${standardURL}contadores/${code}`)
        const res = await axios.get(`${standardURL}contadores/${code}`, {
          headers: {
            'Access-Control-Allow-Origin': '*'
          }})
        const data = res.data
        resolve(
          data
        )
      } catch (err) {
        reject(err)
      }
    })
  }
  static getOpcionesSesion (tipoUsuario) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await axios.get(`${standardURL}sesion/${tipoUsuario}`, {
          headers: {
            'Access-Control-Allow-Origin': '*'
          }})
        const data = res.data
        resolve(
          data.map(post => ({
            ...post
          }))
        )
      } catch (err) {
        reject(err)
      }
    })
  }
  static insertElement (coleccion, datos) {
    console.log(`${standardURL}${coleccion}`)
    return axios.put(`${standardURL}${coleccion}`, datos)
  }
  static deleteElement (coleccion, id) {
    // console.log(`${standardURL}${coleccion}`)
    return axios.delete(`${standardURL}${coleccion}/${id}`)
  }
  static updateElement (coleccion, datos) {
    return axios.post(`${standardURL}${coleccion}`, datos)
  }
}
export default ServiceHandler
